<div class="dialog-wrapper">
  <!-- <h3 mat-dialog-title>Change Password </h3> -->
  <mat-dialog-content>
    <div class="container">
      <form autocomplete="off" [formGroup]="mapForm" novalidate>
        <div class="row">
          <div class="col-sm-12" >
            <div class="card-group">
              <div class="card p-4">


                <div class="card-body col-sm-12">
                  <div class="row">
                    <div class="col-sm-11">
                      <p class="text-muted">Map Data</p>
                    </div>
                    <div class="col-sm-1">
                      <div class="page-title-right row justify-content-end mt-1 d-flex align-items-center float-end">
                        <a (click)="onClose()" matTooltip="Close" class="d-flex align-items-center pr-2 mt-2"><i
                            class="fa fa-window-close" aria-hidden="true"></i></a>
                      </div>
                    </div>
                    <!-- <div class="col-sm-1">
                        <i class="far fa-window-close close_style" (click)="onClose()"></i>
                    </div> -->
                  </div>
                  <div class="col-sm-12">
                    <div class="row">
                      <div class="col-sm-4">
                        <div class="form-group">
                          <div class="">

                            <mat-form-field appearance="outline" class="example-full-width" >
                              <mat-label> Subject</mat-label>
                              <input readonly matInput formControlName="subject" placeholder="Subject">

                            </mat-form-field>


                          </div>
                        </div>
                      </div>
                      <div class="col-sm-4">
                        <div class="form-group">
                          <div class="">

                            <mat-radio-group formControlName="optionlCompalsary" class="example-full-width" >
                              <div class="row">
                                <div class="col-sm-6 p-1  mt-4">
                                  <mat-radio-button value="C">compulsory</mat-radio-button>
                                </div>
                                <div class="col-sm-6 p-1 mt-4">
                                  <mat-radio-button value="O">Optional</mat-radio-button>
                                </div>
                              </div>
                            </mat-radio-group>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-4">
                        <div class="form-group">
                          <div class="">
                            <mat-form-field appearance="outline" class="example-full-width" >
                              <mat-label>Map to</mat-label>
                              <!-- <mat-select #select223 class="colorblack"
                                    formControlName="mapto">
                                    <mat-option value="m">Maths</mat-option>
                                    <mat-option value="p">Physics</mat-option>
                                    <mat-option value="c">Chemistry</mat-option>
                                    </mat-select> -->
                              <mat-select  #select33 placeholder="mapto"
                                class="colorblack" formControlName="mapto">
                                <mat-select-filter *ngIf="select33.focused" [placeholder]="'Filter'"
                                  [displayMember]="'EsCode'" [array]="mapSubjectList"
                                  (filteredReturn)="filteredmapSubjectList =$event"></mat-select-filter>
                                <mat-option *ngFor="let item of filteredmapSubjectList" [value]="item.EsCode" (click)="getdata(item)">
                                  {{item.Code}}
                                </mat-option>
                              </mat-select>
                            </mat-form-field>
                          </div>
                        </div>
                      </div>

                    </div>
                    <div class="row">
                      <div class="col-sm-3"></div>
                      <div class="col-sm-6">
                        <button type="button"
                        class="btn btn-primary my-2 me-2 btn-icon-text floatright btn-raised g-bg-blush2" (click)="onSubmit()" >Update</button>
                      </div>
                      <div class="col-sm-3"></div>
                    </div>
                  </div>
                </div>


              </div>
            </div>
          </div>

        </div>
      </form>


    </div>
  </mat-dialog-content>

</div>